import { useMemo, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { SortingState } from '@tanstack/react-table';
import {
  useAuthUserRestaurant,
  useGetSuppliersQuery,
} from '@durma-soft/gros-sdk';

import { DataTable } from '@/components/shared/data-table';
import { Button } from '@/components/shared/shadcn-ui/button';
import { CreateSupplierModal } from '@/components/restaurant/suppliers/create-supplier-modal';

import { supplierColumns } from '@/config/restaurant/platform-suppliers';

const PlatformSuppliers = () => {
  const { t } = useTranslation();
  const restaurant = useAuthUserRestaurant();

  const [sorting, setSorting] = useState<SortingState>([]);
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  const suppliers = useGetSuppliersQuery({ restaurant_id: restaurant.id });

  const columns = useMemo(() => supplierColumns(t), [t]);

  return (
    <>
      <Helmet>
        <title>{t('suppliers.title')}</title>
      </Helmet>
      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <h1 className="text-lg font-semibold md:text-2xl">
            {t('suppliers.title')}
          </h1>
          <Button onClick={() => setIsCreateOpen(true)}>
            {t('suppliers.create')}
          </Button>
        </div>
        {suppliers.isError ? (
          <p className="p-4 text-center text-sm text-destructive">
            {t('common.error')}
          </p>
        ) : !suppliers.isLoading && (suppliers.data ?? []).length === 0 ? (
          <p className="p-4 text-center text-sm text-muted-foreground">
            {t('suppliers.empty')}
          </p>
        ) : (
          <DataTable
            columns={columns}
            data={suppliers.data ?? []}
            isLoading={suppliers.isLoading}
            sorting={sorting}
            setSorting={setSorting}
          />
        )}
      </div>
      <CreateSupplierModal
        isOpen={isCreateOpen}
        onClose={() => setIsCreateOpen(false)}
      />
    </>
  );
};

export default PlatformSuppliers;
